<template>
  <VDropdown
    placement="bottom-start"
    @apply-show="isFocusLoopActive = true"
    @apply-hide="isFocusLoopActive = false"
    class="tw-inline-flex"
  >
    <button
      class="tw-inline-flex tw-items-center tw-rounded-full tw-px-3 tw-py-2 tw-font-semibold tw-text-neutral-900 tw-transition-colors hover:tw-bg-neutral-50 focus:tw-outline-none focus-visible:tw-ring focus-visible:tw-ring-neutral-200"
    >
      <slot name="icon" />
      {{ name }}
      <ArrowRight
        class="tw-ml-2 tw-w-2 tw-shrink-0 tw-transition-transform"
        :class="[isFocusLoopActive ? 'tw-rotate-[270deg]' : 'tw-rotate-90']"
      />
    </button>
    <template #popper>
      <div
        class="tw-w-48 tw-overflow-x-hidden tw-overflow-y-hidden tw-rounded-lg tw-shadow-md"
      >
        <FocusLoop
          :is-active="isFocusLoopActive"
          :auto-focus="false"
          is-arrows-navigation-active
        >
          <div class="tw-flex tw-flex-col">
            <InertiaLink
              v-for="(item, index) in items"
              :key="index"
              :href="item.href[accessControl.role]"
              class="tw-inline-flex tw-items-center tw-px-5 tw-py-3 tw-text-sm tw-text-neutral-700 tw-transition-colors hover:tw-bg-neutral-50 hover:tw-text-current focus:tw-bg-neutral-100 focus:tw-outline-none"
            >
              <component :is="item.icon" class="tw-mr-4 tw-h-4 tw-w-4" />
              {{ item.name }}
            </InertiaLink>
          </div>
        </FocusLoop>
      </div>
    </template>
  </VDropdown>
</template>

<script setup>
import FocusLoop from '../FocusLoop.vue'
import ArrowRight from '@/assets/images/icons/arrow-right.svg'
import { ref } from 'vue'
import { usePermissionSystem } from '@/shared/composables/usePermissionSystem.js'

defineProps({
  name: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
    default: '',
  },
  items: {
    type: Array,
    default: () => [],
  },
})

const { accessControl } = usePermissionSystem()

const isFocusLoopActive = ref(false)
</script>
